import { AsyncIconButton } from '@texas/components/shared/button/AsyncIconButton';
import { Icons } from '@texas/components/shared/Icons';
import { useTranslation } from 'react-i18next';
import { customerUserEvents } from './events';
import { customerUsersApi } from '@texas/api/endpoints/customerUsersApi';
import { IconButton, Tooltip } from '@chakra-ui/react';

interface Props {
  isMain: boolean;
  customerUserId: number;
  onChangeCustomTypeClick?: () => void;
}

export function IconUtilButtons({
  isMain,
  customerUserId,
  onChangeCustomTypeClick,
}: Props) {
  const { t } = useTranslation();

  if (onChangeCustomTypeClick) {
    return (
      <>
        <ChangeCustomUserTypeComponent onClick={onChangeCustomTypeClick} />
        <AsyncIconButton
          tooltip={t('customerUser.remove')}
          size="xs"
          variant="avatar-badge"
          icon={<Icons.Close />}
          onPerformed={() => {
            customerUserEvents.customerUserRemoved.dispatch();
          }}
          primaryRequest={customerUsersApi.removeUser}
          args={[customerUserId]}
        />
      </>
    );
  }

  if (isMain) {
    return (
      <AsyncIconButton
        tooltip={t('customerUser.remove')}
        size="xs"
        variant="avatar-badge"
        icon={<Icons.Close />}
        onPerformed={() => {
          customerUserEvents.customerUserRemoved.dispatch();
        }}
        primaryRequest={customerUsersApi.removeUser}
        args={[customerUserId]}
      />
    );
  }

  return (
    <>
      <AsyncIconButton
        tooltip={t('customerUser.setMain')}
        icon={<Icons.Flag />}
        size="xs"
        variant="avatar-badge"
        onPerformed={() => {
          customerUserEvents.onCustomerUserSetMain.dispatch();
        }}
        primaryRequest={customerUsersApi.setMain}
        args={[customerUserId]}
      />
      <AsyncIconButton
        tooltip={t('customerUser.remove')}
        icon={<Icons.Close />}
        size="xs"
        variant="avatar-badge"
        onPerformed={() => {
          customerUserEvents.customerUserRemoved.dispatch();
        }}
        primaryRequest={customerUsersApi.removeUser}
        args={[customerUserId]}
      />
    </>
  );
}

function ChangeCustomUserTypeComponent({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();

  return (
    <Tooltip label={t('customerUser.changeCustomRole')}>
      <IconButton
        size="xs"
        variant="avatar-badge"
        icon={<Icons.Pencil />}
        onClick={onClick}
        aria-label={t('customerUser.changeCustomRole')}
      />
    </Tooltip>
  );
}
